import {Injectable} from '@angular/core';
import {WorkInfoStore} from './work-info/work-info.store';
import {WorkInfoQuery} from './work-info/work-info.query';
import {StoreInterface} from '../interfaces/store.interface';

@Injectable({providedIn: 'root'})
export class WorkInfoStoreService {
  private stores = new Map();

  constructor() {
  }

  getOrCreateStore(name: string): StoreInterface<WorkInfoStore, WorkInfoQuery> {
    if (!name) {
      return;
    }

    if (this.stores.has(name)) {
      return this.getState(name);
    } else {
      const store = new WorkInfoStore(name);
      const query = new WorkInfoQuery(store);

      const state = {store, query};
      this.stores.set(name, state);
      return state;
    }
  }

  private getState(name: string) {
    return this.stores.get(name);
  }
}
